import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import SignupModal from "@/components/SignupModal";
import NextMoveModal from "@/components/NextMoveModal";
import TestimonialTicker from "@/components/TestimonialTicker";

import AwardStrip from "@/components/landing/AwardStrip";
import Navigation from "@/components/landing/Navigation";
import Hero from "@/components/landing/Hero";
import OwnerStory from "@/components/landing/OwnerStory";
import TheApproach from "@/components/landing/TheApproach";
import DelegationDomains from "@/components/landing/DelegationDomains";
import MeetJonathan from "@/components/landing/MeetJonathan";
import OwnerBehavior from "@/components/landing/OwnerBehavior";
import Qualification from "@/components/landing/Qualification";
import CtaAndSister from "@/components/landing/CtaAndSister";
import AwardContext from "@/components/landing/AwardContext";
import EpicBanner from "@/components/landing/EpicBanner";
import Footer from "@/components/landing/Footer";

export default function Landing() {
  const [signupOpen, setSignupOpen] = useState(false);
  const [nextMoveOpen, setNextMoveOpen] = useState(false);
  const [content, setContent] = useState({});
  const [navBadgeVisible, setNavBadgeVisible] = useState(true);

  useEffect(() => { api.get("/content").then((r) => setContent(r.data)).catch(() => {}); }, []);
  useEffect(() => {
    const onScroll = () => setNavBadgeVisible(window.scrollY < 10);
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const c = (k, fallback = "") => content[k] || fallback;
  const openSignup = () => setSignupOpen(true);
  const openNextMove = () => setNextMoveOpen(true);

  return (
    <div className="min-h-screen paper-grain text-cvc-ink">
      <AwardStrip c={c} />
      <Navigation onSignup={openSignup} onNextMove={openNextMove} navBadgeVisible={navBadgeVisible} />
      {/* Slender fade-based testimonial ticker — sits just under the nav, non-intrusive */}
      <TestimonialTicker content={content} />
      <Hero c={c} onSignup={openSignup} onNextMove={openNextMove} />
      <OwnerStory />

      <div className="max-w-7xl mx-auto px-6 lg:px-12"><div className="hairline" /></div>

      <TheApproach />

      <div className="max-w-7xl mx-auto px-6 lg:px-12"><div className="hairline" /></div>

      <DelegationDomains />
      <MeetJonathan c={c} />
      <OwnerBehavior />
      <Qualification />
      <CtaAndSister onSignup={openSignup} />
      <AwardContext />
      <EpicBanner />
      <Footer />

      <SignupModal open={signupOpen} onOpenChange={setSignupOpen} />
      <NextMoveModal open={nextMoveOpen} onOpenChange={setNextMoveOpen} />
    </div>
  );
}
